export interface WebsiteSharedState {
    mega_menu: IMegaMenu;
    mou_gallery: IMouGallery[];
    mou_gallery_details: IMouGallery[];
    error: IError;
};

export const initialState: WebsiteSharedState = {
    mega_menu: null,
    mou_gallery: null,
    mou_gallery_details: null,
    error: {
        mega_menu_error: null,
        mou_gallery_error: null,
        mou_gallery_details_error: null
    }
};

export interface IMegaMenu {
    pg: IPg[],
    ug: IUg[],
    inter: IInter[],
    school: ISchool[]
}

export interface IError {
    mega_menu_error: any;
    mou_gallery_error: any;
    mou_gallery_details_error: any;
}

export interface IPg {
    dept_id: number;
    mid: number;
    dept_name: string;
    domain_id: number;
    domain_name: string;
    tech_id: number;
    tech_name: string;
}

export interface IUg {
    dept_id: number;
    dept_name: string;
    mid: number;
    menu_name: string;
    oid: number;
    organ_name: string;
    domain_id: number;
    domain_name: string;
    tech_id: number;
    tech_name: string;
}

export interface IInter {
    dept_id: number;
    dept_name: string;
    mid: number;
    menu_name: string;
    domain_id: number;
    domain_name: string;
    tech_id: number;
    tech_name: string;
}

export interface ISchool {
    dept_id: number;
    dept_name: string;
    mid: number;
    menu_name: string;
    domain_id: number;
    domain_name: string;
    tech_id: number;
    tech_name: string;
}

export interface IMouGallery {
    main_id: number;
    title: string;
    m_image: string;
    public_link: string;
    img_id: number;
    mou_title: string;
    img_file: string;
}
